import type { Orientation } from '@lilith-arcana-os/domain';

import { uniformBoolean, type RandomByteSource } from './uniform-index';

export async function drawOrientation(source: RandomByteSource): Promise<Orientation> {
  return (await uniformBoolean(source)) ? 'reversed' : 'upright';
}

export async function drawOrientations(
  source: RandomByteSource,
  count: number,
): Promise<Orientation[]> {
  if (!Number.isInteger(count) || count < 0) {
    throw new RangeError('count must be a non-negative integer.');
  }

  const values: Orientation[] = [];

  for (let index = 0; index < count; index += 1) {
    values.push(await drawOrientation(source));
  }

  return values;
}
